import SettingsButton from '@/views/buttons/SettingsButton'
import { mapGetters, mapMutations } from 'vuex'
import Moment from 'moment'

export const base_widget = {

  components: {
    SettingsButton
  },

  props: ['widget', 'print', 'customData'],

  data () {
    return {
      colorsArray: [
        '#0a4e91', '#63b598', '#ce7d78', '#a48a9e', '#c6e1e8', '#648177' ,'#0d5ac1' ,'#1c0365' ,'#14a9ad' ,'#4ca2f9' ,'#a4e43f' ,'#d298e2' ,'#6119d0',
        '#d2737d' ,'#c0a43c' ,'#f2510e' ,'#651be6' ,'#79806e' ,'#61da5e' ,'#cd2f00' ,
        '#9348af' ,'#01ac53' ,'#c5a4fb' ,'#996635','#b11573' ,'#4bb473' ,'#75d89e' ,
        '#2f3f94' ,'#2f7b99' ,'#da967d' ,'#34891f' ,'#b0d87b' ,'#ca4751' ,'#7e50a8' ,
        '#c4d647' ,'#e0eeb8' ,'#11dec1' ,'#289812' ,'#566ca0' ,'#ffdbe1' ,'#2f1179' ,
        '#935b6d' ,'#916988' ,'#513d98' ,'#aead3a', '#9e6d71', '#4b5bdc', '#0cd36d',
        '#250662', '#cb5bea', '#228916', '#ac3e1b', '#df514a', '#539397', '#880977',
        '#f697c1', '#ba96ce', '#679c9d', '#c6c42c', '#5d2c52', '#48b41b', '#e1cf3b',
        '#5be4f0', '#57c4d8', '#a4d17a', '#225b8', '#be608b', '#96b00c', '#088baf',
        '#f158bf', '#e145ba', '#ee91e3', '#05d371', '#5426e0', '#4834d0', '#802234',
        '#6749e8', '#0971f0', '#8fb413', '#b2b4f0', '#c3c89d', '#c9a941', '#41d158',
        '#fb21a3', '#51aed9', '#5bb32d', '#807fb', '#21538e', '#89d534', '#d36647',
        '#7fb411', '#0023b8', '#3b8c2a', '#986b53', '#f50422', '#983f7a', '#ea24a3',
        '#79352c', '#521250', '#c79ed2', '#d6dd92', '#e33e52', '#b2be57', '#fa06ec',
        '#1bb699', '#6b2e5f', '#64820f', '#1c271', '#21538e', '#89d534', '#d36647',
        '#7fb411', '#0023b8', '#3b8c2a', '#986b53', '#f50422', '#983f7a', '#ea24a3',
        '#79352c', '#521250', '#c79ed2', '#d6dd92', '#e33e52', '#b2be57', '#fa06ec',
        '#1bb699', '#6b2e5f', '#64820f', '#1c271', '#9cb64a', '#996c48', '#9ab9b7',
        '#06e052', '#e3a481', '#0eb621', '#fc458e', '#b2db15', '#aa226d', '#792ed8',
        '#73872a', '#520d3a', '#cefcb8', '#a5b3d9', '#7d1d85', '#c4fd57', '#f1ae16',
        '#8fe22a', '#ef6e3c', '#243eeb', '#1dc18', '#dd93fd', '#3f8473', '#e7dbce',
        '#421f79', '#7a3d93', '#635f6d', '#93f2d7', '#9b5c2a', '#15b9ee', '#0f5997',
        '#409188', '#911e20', '#1350ce', '#10e5b1', '#fff4d7', '#cb2582', '#ce00be',
        '#32d5d6', '#17232', '#608572', '#c79bc2', '#00f87c', '#77772a', '#6995ba',
        '#fc6b57', '#f07815', '#8fd883', '#060e27', '#96e591', '#21d52e', '#d00043',
        '#b47162', '#1ec227', '#4f0f6f', '#1d1d58', '#947002', '#bde052', '#e08c56',
        '#28fcfd', '#bb09b', '#36486a', '#d02e29', '#1ae6db', '#3e464c', '#a84a8f',
        '#911e7e', '#3f16d9', '#0f525f', '#ac7c0a', '#b4c086', '#c9d730', '#30cc49',
        '#3d6751', '#fb4c03', '#640fc1', '#62c03e', '#d3493a', '#88aa0b', '#406df9',
        '#615af0', '#4be47', '#2a3434', '#4a543f', '#79bca0', '#a8b8d4', '#00efd4',
        '#7ad236', '#7260d8', '#1deaa7', '#06f43a', '#823c59', '#e3d94c', '#dc1c06',
        '#f53b2a', '#b46238', '#2dfff6', '#a82b89', '#1a8011', '#436a9f', '#1a806a',
        '#4cf09d', '#c188a2', '#67eb4b', '#b308d3', '#fc7e41', '#af3101', '#ff065',
        '#71b1f4', '#a2f8a5', '#e23dd0', '#d3486d', '#00f7f9', '#474893', '#3cec35',
        '#1c65cb', '#5d1d0c', '#2d7d2a', '#ff3420', '#5cdd87', '#a259a4', '#e4ac44',
        '#1bede6', '#8798a4', '#d7790f', '#b2c24f', '#de73c2', '#d70a9c', '#25b67',
        '#88e9b8', '#c2b0e2', '#86e98f', '#ae90e2', '#1a806b', '#436a9e', '#0ec0ff',
        '#f812b3', '#b17fc9', '#8d6c2f', '#d3277a', '#2ca1ae', '#9685eb', '#8a96c6',
        '#dba2e6', '#76fc1b', '#608fa4', '#20f6ba', '#07d7f6', '#dce77a', '#77ecca'
      ],
      fixedCardHeader: false,
      colorsHash: {}
    }
  },

  computed: {
    ...mapGetters([
      'startDate',
      'endDate',
      'compareStartDate',
      'compareEndDate',
      'currentClient',
      'tempCurrentClient',
      'dashboard'
    ]),
    title: {
      get: function(){return this.widget.title},
      set: function(newTitle) {
        this.widget.title = newTitle
      }
    },
    hideTableControls: function() { return this.widget.hide_table_controls },
    hideMetricLabel: function() { return this.widget.hide_metric_label },
    id: function(){ return this.widget.id },
    dashboardId: function(){ return this.widget.dashboard_id },
    ownerId: function(){ return this.widget.owner_id },
    locked: function(){ return this.widget.locked },
    disableLegend: function(){ return this.widget.disable_legend },
    dashboardLocked: function(){ return this.dashboard.locked },
    validDates: function () {
      return Moment(this.startDate, 'MMM, D, YYYY').toDate() < Moment(this.endDate, 'MMM, D, YYYY').toDate()
    },
    validCompareDates: function () {
      return Moment(this.compareStartDate, 'MMM, D, YYYY').toDate() < Moment(this.compareEndDate, 'MMM, D, YYYY').toDate()
    }
  },

  watch: {
    startDate: function () {
      if (this.validDates) {
        this.getData()
      }
    },
    endDate: function () {
      if (this.validDates) {
        this.getData()
      }
    },
    compareStartDate: function () {
      if (this.widget.disableDataComparison) {
        return false
      } else {
        this.getData()
      }
    },
    compareEndDate: function () {
      if (this.widget.disableDataComparison) {
        return false
      } else {        
        this.getData()
      }
    }
  },

  created () {
    this.$eventBus.$on('updateWidget'+this.id, widget => this.update(widget))
    this.getData()
    this.isOverflown()
  },

  methods: {
    ...mapMutations(['addWidgetData']),
    widgetData () {
      return this.widget
    },
    handleClickThrough () {
      if (!this.widget.click_through || !this.widget.click_through_section) {
        return false
      } else {
        this.setCurrentSection(this.widget.click_through_section)
      }
    },
    setCurrentSection ( sectionId ) {
      this.$eventBus.$emit('changeCurrentTab', sectionId)
    },
    deleteWidget (shared) {
      var params = {}
      if (shared === 'true') {
        params = { shared: true }
      }
      this.$http.delete('/dashboards/'+ this.dashboardId +'/widgets/' + this.id, {params :params})
        .then(function(){this.$emit('deleteWidget')}.bind(this))
        .catch((e) => console.log(e))
    },
    update (updates, callback) {
      this.$http.patch('/dashboards/'+ this.dashboardId +'/widgets/' + this.id, updates)
        .then(function(){
          callback()
          this.title = updates.title
        }.bind(this))
        .catch((e) => this.notifyError(e))
    },
    isOverflown () {
      var card = document.getElementsByClassName('card');
      for (var i = 0; i < card.length; i++) {
        if (card[i].offsetHeight < card[i].scrollHeight ||
          card[i].offsetWidth < card[i].scrollWidth) {
            return this.fixedCardHeader = true
        }
      }
    },
    getData () {
      this.value = 'Loading...'
      var currentClient = this.currentClient
      if (this.tempCurrentClient){
        currentClient = this.tempCurrentClient
      }
      if (!currentClient) {
        this.loadMessage = 'Unable To Load Data, Please select a client'
        return false
      }
      this.rows = []
      var params = {
        start_date: this.startDate,
        end_date: this.endDate,
        client_id: currentClient.id
      }
      if (this.compareStartDate && this.compareEndDate && !this.widget.disableDataComparison){
        params.compare_start_date = this.compareStartDate
        params.compare_end_date = this.compareEndDate
      }
      if (currentClient.domain){
        params.domain = currentClient.domain
      } else {
        params.client_group_id = currentClient.id
      }
      if (this.customData) {
        var data = []
        this.customData.forEach((widget) => {
          this.$http.get('dashboards/'+ this.dashboardId +'/widgets/' + widget.id, {params: params})
            .then(response => {
              data.push(response.data.data[0].data)
              if (this.customData.indexOf(widget) === this.customData.length - 1) {
                this.setData(data)
              }
            })
            .catch((e) => this.notifyError(e))
        })
      } else {
        this.$http.get('dashboards/'+ this.dashboardId +'/widgets/' + this.id, {params: params})
          .then(response => this.setData(response))
          .catch((e) => this.notifyError(e))
      }
    },
    notifyError (error) {
      console.log('base_widget error: ', error)
      this.loadMessage = 'Error - Unable To Load Data'
    },
    setData (response) {
      console.warn('setData(): override me in ', this.title, response)
    },

    setTooltipsLabels (data) {
      if (typeof data.data.value === 'undefined'){
        labels = data.data.datasets.map (dataset => dataset.label)
      } else {
        var labels = [[],[]]
        data.data.value.labels.forEach(function(label, index){
          labels[0].push(label)
          labels[1].push(data.data.compare_value.labels[index])
        })
      }
      return labels
    },

    setLabels (data) {
      var labels = []
      if (typeof data.value === 'undefined'){
        labels = data.labels
      } else {
        labels = data.value.labels.map(function(label, index){
          return label + '/' + data.compare_value.labels[index]
        })
      }
      return labels
    },
    saveWidgetData (data, labels) {
      let widgetData = {
        id: this.id,
        title: this.title,
        labels: labels,
        data: data
      }
      this.addWidgetData(widgetData)
    },
    setDatasets (data, multiYAxis) {
      var sets = []
      var datasets = []
      if (typeof data.value === 'undefined'){
        datasets = data.datasets
      } else {
        datasets.push(data.value.datasets)
        datasets.push(data.compare_value.datasets)
        datasets = datasets.flat(Infinity)
      }
      if(datasets.length > 1) {
        this.makeColorsHash(datasets)
      }
      datasets.forEach(function(dataset, index){
        var settings = {
          label: dataset.label,
          type: dataset.type,
          fill: dataset.fill,
          backgroundColor: this.setBackgroundColor(dataset.label, index),
          data: dataset.data,
          borderColor: this.borderColor[index],
          stack: dataset.stack
        }
        if (multiYAxis) {
          settings.yAxisID = dataset.label + '_axis'
        }
        sets.push(settings)
      }.bind(this))
      return sets
    },

    setBackgroundColor(label, index) {
      if(this.colorsHash[label]) {
        if (this.colorsHash[label] !== 'transparent') {
          return this.colorsHash[label]
        } else {
          return 'transparent'
        }
      } else {
        return this.colors[index] || 'transparent'
      }
    },

    makeColorsHash(datasets) {
      let hash = {}
      datasets.map( (index) => {
        if(!hash[index]) {
          hash[index] = this.colors[index]
        }
      } )
      this.colorsHash = hash
    }
  }

}
